<template>
  <div  class="container-fluid px-0" style="background-color: white;">
    <h1 class="page-title letraDelTitulo enMayusculas col-12">Convocatorias</h1>   
      <div class="row px-lg-5">
       
       
     <div class="row tablaDeVinculos">
        <table class="table table-striped table-hover table-bordered mt-4">
            <thead class="thead-dark">
                 <th class="titulo w-5 text-center" ></th>
                  <th class="titulo w-20 text-center" >Convocatorias Activas</th>
                  <th class="titulo w-10 text-center" >Enlace</th>
            </thead>
            <tbody>
                <tr v-for="(callAvailable, indice) in CallsAvailable" v-bind:key="callAvailable.idConvocatoria">
                     <td class="text-center">{{(indice + 1)}}</td> 
                    <td v-if ="callAvailable.TituloConvocatoria ==STRING_EMPTY" class="text-justify">No existen convocatorias disponibles</td>
                    <td v-else class="text-justify">{{callAvailable.TituloConvocatoria}}</td>
                    
                    <td  class="w-10 text-center align-middle" :class="{ 'p-0': callAvailable.RutaConvocatoria.includes('http') }">
                      <div v-if="callAvailable.RutaConvocatoria.includes('http') || callAvailable.RutaConvocatoria.includes('https')">
                        <a :href="callAvailable.RutaConvocatoria" target="_blank">"Ir a Convocatoria"</a>             
                      </div>
                      <router-link v-else :to="callAvailable.RutaConvocatoria">"Ir a Convocatoria"</router-link>
                    </td>   
                </tr>
                <tr v-if="CallsAvailable.length ==0">
                    <td class="text-center">0</td> 
                    <td  class="text-justify">No existen convocatorias disponibles</td>
                </tr>
            </tbody>
        </table>
    </div>
      
    
    
    </div>    
    <div id="inferior-superior-menu" class="w-100">
    </div>






  </div>
</template>



<script>
import enumeraciones from "@/../static/js/enumeraciones";
  import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
  import api from '@/../static/js/api';
  import axios from 'axios';
  import VueMask from 'v-mask';

export default {
data() { 
      return {
        STRING_EMPTY : "",
        CallsAvailable: {}
      }
    },
methods: {
GetCallsAvailable:async function(){
     const SERVIDOR = api.conexion;
     const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.convocatoriasWeb.ObtenerConvocatorias;
     const END_POINT = SERVIDOR+METODO_API_AGREGAR;
      return axios.post(END_POINT,).then(async response => {
    console.log("response:::::",response);
    console.log("response2:::::",response.data.Convocatorias);
    
    if(response.data.Convocatorias.SiHayError){
                    bootbox.dialog({                  
                                message: '<div style="text-align:center"><i class="fas fa-times" style="color: #cf0707;font-size:3em"></i><br> <br> <p style="font-size:2em" class="text-center mb-0"> Ha ocurrido un error intentelo mas tarde.</p></div>',
                                buttons: {
                                cancel: {
                                label: "Cerrar",
                                className: 'btn-danger',
                            }
                        }
                    });
                               
                }else{
                    
                   this.CallsAvailable = response.data.Convocatorias;
                    
                }


}).catch(e => {
                console.log("A sucedido un error en el sistema::",e.message);      
                bootbox.dialog({                  
                                message: '<div style="text-align:center"><i class="fas fa-times" style="color: #cf0707;font-size:3em"></i><br> <br> <p style="font-size:2em" class="text-center mb-0"> Ha ocurrido un error intentelo mas tarde.</p></div>',
                                buttons: {
                                cancel: {
                                label: "Entendido",
                                className: 'btn-info',
                            }
                        }
                    });
             });
}
  
},
mounted() {
      this.GetCallsAvailable();
    }    
}
</script>

<style scoped>
    

  .w-5 {
    width: 5% !important;
  }

  .w-10 {
    width: 10% !important;
  }

  .w-20 {
    width: 20% !important;
  }

  .p-0 {
    padding-top: 5px !important;
  }
   
  .p-10 {
    padding-top: 25px !important;
  }

  .tablaDeVinculos .titulo {
    text-align: center;
    font-size: 1em;
  }

    .tablaDeVinculos table tbody tr td a {
      font-size: 1rem;
    }

    

    #inferior-superior-menu {
    display: flex;
    height: 30px;
    min-height: 30px;
    max-height: 30px;
    background-color: rgb(255, 255, 255);
    /* z-index: 10 !important; */
    position: relative;
  }

  .enMayusculas {
    text-transform: uppercase;
  }

  .page-title {
    background-color: rgb(50,50,50);
    color: #FFF;
    padding: 2vh 20vw;
  }

  @media (max-width: 600px) {
    .page-title{
      font-size: 2em;
    }

    h2{
      font-size: 1.8em;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Convocatorias/ConvocatoriasDisponibles.vue